module.exports = __webpack_public_path__ + "../resources/img/social-login-google.96714ac4.svg";